import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { Icon } from "@iconify/react";

import { Modal, Button, Form } from "react-bootstrap";
import { BiCheckCircle } from "react-icons/bi";
import { useNavigate, useLocation } from "react-router-dom";
import { PDFViewer, pdf } from "@react-pdf/renderer";
import InvoicePDF from "../components/InvoicePDF";
import InvoicePDFA5 from "../components/InvoicePDFA5";
import QuoteInvoiceA4 from "../components/QuoteInvoiceA4";
import QuoteA5 from "../components/QuoteA5";
import InvoiceCoverPDF from "../components/InvoiceCoverPDF";
import ReturnModal from "../components/ReturnModal";
import GstPortalModal from "../components/GstPortalModal";
import { buildJamaVoucherData } from "../components/JamaVoucherPDF";
import JamaVoucherPreviewModal from "../components/JamaVoucherPreviewModal";
import { Buffer } from "buffer";
import {
  getUserData,
  getCurrentPinType,
  getQuoteInvoiceListScope,
  QUOTE_INVOICE_LIST_SCOPE_EVENT,
} from "./const";
import { toast } from "react-hot-toast";
import Pagination from "../components/Pagination";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";
import { formatIndianRupee } from "../utils/formatLiveRate";
import { createErpSocket } from "../utils/socketIo";
import Select from "react-select";
import {
  listBankAccounts,
  listMetalGroups,
  listProductGroups,
  listCustomerUsers,
  listSales,
  showSale,
  settlementSale,
  isErpApiSuccess,
} from "../erpClient";
import {
  normalizeListSalesRows,
  getLegacySaleDetailsFromShowResponse,
  isSalesApiSuccess,
  createSalesIdempotencyKey,
  mapSocketSaleToInvoiceRow,
  normalizeInvoiceTableStatus,
  ERP_SALES_LIST_INVALIDATE_EVENT,
} from "../utils/salesErpAdapter";
import { commandBus } from "../desktop/commands/CommandBus";
import { getDesktopEnv } from "../desktop/desktopEnv";
import {
  formatApiPaymentDisplayLabel,
  isUrdLinkedPaymentMode,
} from "../utils/paymentLinesErpAdapter";
import {
  resolveSaleEinvoiceFields,
  buildSignedQrDataUrl,
} from "../utils/einvoiceFields";
import { parseApiPagination } from "../utils/parseApiPagination";
// Add this line to make Buffer available globally
window.Buffer = Buffer;

// CSS styles for row colors - FULL BACKGROUND COLOR ONLY with 2% opacity
const rowStyles = `
  .repair-invoice-row {
    background-color: rgba(255, 0, 0, 0.02) !important;
    color: #000 !important;
  }
  .repair-invoice-row td {
    background-color: rgba(255, 0, 0, 0.02) !important;
    color: #000 !important;
  }
  .regular-sale-row {
    background-color: rgba(0, 128, 255, 0.02) !important;
    color: #000 !important;
  }
  .regular-sale-row td {
    background-color: rgba(0, 128, 255, 0.02) !important;
    color: #000 !important;
  }
  
  /* Badge styles for better text visibility */
  .badge-repair-invoice {
    background-color: #f44336 !important;
    color: #fff !important;
    font-weight: bold !important;
  }
  .badge-regular-sale {
    background-color: #2196f3 !important;
    color: #fff !important;
    font-weight: bold !important;
  }
  
  /* Row background by payment status (low opacity) */
  .status-paid-row,
  .status-paid-row td {
    background-color: rgba(25, 135, 84, 0.02) !important; /* green */
  }
  .status-pending-row,
  .status-pending-row td {
    background-color: rgba(220, 53, 69, 0.03) !important; /* red */
  }
  .status-partial-row,
  .status-partial-row td {
    background-color: rgba(255, 193, 7, 0.02) !important; /* amber */
  }
  .status-returned-row,
  .status-returned-row td {
    background-color: rgba(140, 233, 247, 0.12) !important; /* cyan/turquoise to match badge */
  }
  
  /* Compact table spacing specifically for Invoice table */
  .invoice-table th,
  .invoice-table td {
    padding: 0.5rem 0.6rem !important; /* reduce vertical and horizontal gaps */
  }
  .invoice-table .badge {
    padding: 0.3em 0.5em !important;
    font-size: 0.75rem !important;
  }
  .invoice-table .btn.btn-sm {
    padding: 0.25rem 0.4rem !important;
  }
`;

// Inject CSS styles with unique ID to avoid conflicts
if (typeof document !== "undefined") {
  // Remove existing stylesheet if it exists
  const existingStyle = document.getElementById("invoice-row-styles");
  if (existingStyle) {
    existingStyle.remove();
  }

  const styleSheet = document.createElement("style");
  styleSheet.id = "invoice-row-styles";
  styleSheet.type = "text/css";
  styleSheet.innerText = rowStyles;
  document.head.appendChild(styleSheet);
}

const SETTLEMENT_METHOD_OPTIONS = [
  { value: "cash", label: "Cash" },
  { value: "cheque", label: "Cheque" },
  { value: "bank_transfer", label: "Bank Transfer" },
  { value: "upi", label: "UPI" },
  { value: "card", label: "Card" },
  { value: "old_gold", label: "Old Gold" },
  { value: "old_silver", label: "Old Silver" },
  { value: "kasar", label: "Kasar" },
  { value: "scheme", label: "Scheme" },
  { value: "order", label: "Order" },
  { value: "os", label: "OS" },
  { value: "wallet", label: "Wallet" },
];

const SETTLEMENT_METHOD_LABELS = {
  cash: "Cash",
  cheque: "Cheque",
  bank_transfer: "Bank Transfer",
  upi: "UPI",
  card: "Card",
  old_gold: "Old Gold",
  old_silver: "Old Silver",
  kasar: "Kasar",
  scheme: "Scheme",
  order: "Order",
  os: "OS",
  wallet: "Wallet",
};

const createDefaultSettlementRows = () => [
  {
    id: 1,
    pay_mode: "",
    type: "",
    remarks: "",
    amount: "",
  },
];

/** Quote-mode invoice list scope: "quotation" → type list; "all" → type mixed (still /quote). */

function Invoice() {
  const desktopEnv = getDesktopEnv();
  const [invoices, setInvoices] = useState([]);
  const [userss, setUserss] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("Active");
  const [quoteListScope, setQuoteListScope] = useState(getQuoteInvoiceListScope);
  const [pinType, setPinType] = useState(
    () => getCurrentPinType() || localStorage.getItem("currentPinType") || "access",
  );
  const isQuoteMode = String(pinType).toLowerCase() === "quote";
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isHeaderHovered, setIsHeaderHovered] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [showGstPortalModal, setShowGstPortalModal] = useState(false);
  const [gstPortalInvoiceIds, setGstPortalInvoiceIds] = useState([]);
  const [showPdfSizeModal, setShowPdfSizeModal] = useState(false);
  const [pdfPaperSize, setPdfPaperSize] = useState("A4");
  const [selectedInvoicesForPdf, setSelectedInvoicesForPdf] = useState([]);
  const [showCoverModal, setShowCoverModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [productGroups, setProductGroups] = useState([]);
  const [metalGroups, setMetalGroups] = useState({});
  const [bankAccounts, setBankAccounts] = useState({});
  // Add a state to track if bank accounts have been loaded (even if empty)
  const [bankAccountsLoaded, setBankAccountsLoaded] = useState(false);
  const [showSettlementModal, setShowSettlementModal] = useState(false);
  const [selectedInvoiceForSettlement, setSelectedInvoiceForSettlement] =
    useState(null);
  const [settlementInvoiceDetails, setSettlementInvoiceDetails] =
    useState(null);
  const [settlementRows, setSettlementRows] = useState(
    createDefaultSettlementRows(),
  );
  const [existingSettlementPayments, setExistingSettlementPayments] = useState(
    [],
  );
  const [isSettlementLoading, setIsSettlementLoading] = useState(false);
  const [isSettlementSaving, setIsSettlementSaving] = useState(false);
  const [isPreviousPaymentsExpanded, setIsPreviousPaymentsExpanded] =
    useState(false);
  const [showSettlementVoucherPreview, setShowSettlementVoucherPreview] =
    useState(false);
  const [settlementVoucherData, setSettlementVoucherData] = useState(null);
  const [socket, setSocket] = useState(null);
  const { buttonClass, tableClass, cardClass } = useButtonTableStyle();
  const userData = getUserData();

  const addSettlementRow = () => {
    setSettlementRows((prevRows) => [
      ...prevRows,
      {
        id: prevRows.length + 1,
        pay_mode: "",
        type: "",
        remarks: "",
        amount: "",
      },
    ]);
  };

  const handleSettlementRowChange = (rowId, field, value) => {
    setSettlementRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id !== rowId) return row;
        if (field === "pay_mode" && value === "kasar") {
          return { ...row, pay_mode: value, type: "" };
        }
        return { ...row, [field]: value };
      }),
    );
  };

  const handleSettlementAmountFocus = (rowId) => {
    if (
      settlementRows.length > 0 &&
      rowId === settlementRows[settlementRows.length - 1].id
    ) {
      addSettlementRow();
    }
  };

  const handleSettlementRowRemove = (rowId) => {
    setSettlementRows((prevRows) => {
      if (prevRows.length === 1) {
        return prevRows;
      }
      const updated = prevRows
        .filter((row) => row.id !== rowId)
        .map((row, index) => ({ ...row, id: index + 1 }));
      return updated.length > 0 ? updated : createDefaultSettlementRows();
    });
  };

  // Return modal states
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [selectedInvoiceForReturn, setSelectedInvoiceForReturn] =
    useState(null);
  const [bankAccountsList, setBankAccountsList] = useState([]);
  const parseNumericValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return 0;
    }
    const numeric = parseFloat(value);
    return Number.isNaN(numeric) ? 0 : numeric;
  };

  const settlementGrandTotal = useMemo(() => {
    if (settlementInvoiceDetails) {
      const totalValue =
        settlementInvoiceDetails.grand_total ??
        settlementInvoiceDetails.final_amount ??
        settlementInvoiceDetails.grandTotal;
      return parseNumericValue(totalValue);
    }
    if (selectedInvoiceForSettlement) {
      return parseNumericValue(selectedInvoiceForSettlement.grandTotal);
    }
    return 0;
  }, [settlementInvoiceDetails, selectedInvoiceForSettlement]);

  const settlementRemainingAmount = useMemo(() => {
    if (settlementInvoiceDetails) {
      return parseNumericValue(
        settlementInvoiceDetails.remaining_amount ??
        settlementInvoiceDetails.remainingAmount,
      );
    }
    if (selectedInvoiceForSettlement) {
      return parseNumericValue(selectedInvoiceForSettlement.remainingAmount);
    }
    return 0;
  }, [settlementInvoiceDetails, selectedInvoiceForSettlement]);

  const newSettlementAmountTotal = useMemo(
    () =>
      settlementRows.reduce(
        (sum, row) => sum + parseNumericValue(row.amount),
        0,
      ),
    [settlementRows],
  );

  const fetchUserss = async () => {
    try {
      const response = await listCustomerUsers({ search: "" });
      const userData = Array.isArray(response?.data?.customers)
        ? response.data.customers
        : Array.isArray(response?.data?.items)
          ? response.data.items
          : Array.isArray(response?.data)
            ? response.data
            : [];

      if (isErpApiSuccess(response)) {
        const userMap = {};

        userData.forEach((user) => {
          // Make sure we're using the correct ID field
          const userId = user.id;
          if (userId) {
            userMap[userId] = {
              name: user.name || user.customer_name || "N/A",
              mobile: user.mobile || user.phone || "N/A",
              email: user.email || "",
              state: user.state || "0",
              city: user.city || "",
              address: user.address || "",
              aadhar_no: user.aadhar_no || "",
              pan_no: user.pan_no || "",
              GST_number: user.GST_number || "",
              company_name: user.company_name || "",
              company_address: user.company_address || "",
              reference: user.reference || "",
              status: user.status || "1",
            };
          }
        });

        setUserss(userMap);
      } else {
        console.error("Unexpected user data format:", response);
      }
    } catch (error) {
      console.error("Error fetching userss:", error);
    }
  };

  const isFetching = useRef(false);
  /** Reused on settlement retries so duplicate ledger posts are avoided */
  const settlementIdempotencyKeyRef = useRef(null);

  const fetchInvoices = useCallback(
    async (page = 1, limit = 10, search = "") => {
      if (isFetching.current) return;
      isFetching.current = true;
      setLoading(true);
      try {
        const inQuote =
          String(getCurrentPinType() || "").toLowerCase() === "quote";
        // Stay on quote base URL; "All" uses type mixed for mixed quote+invoice rows.
        const listType =
          inQuote && quoteListScope === "all" ? "mixed" : "list";

        const response = await listSales({
          search: search.trim(),
          page,
          limit,
          type: listType,
        });

        if (isSalesApiSuccess(response)) {
          const processedInvoices = normalizeListSalesRows(response).map(
            (inv) => ({
              ...inv,
              payments: (inv.payments || []).map((payment) => {
                const isUrd =
                  isUrdLinkedPaymentMode(payment?.payment_mode) ||
                  Number(payment?.urd_document_id) > 0;
                return {
                  ...payment,
                  bank_name: isUrd
                    ? formatApiPaymentDisplayLabel(payment)
                    : payment.bank_name || "Unknown Bank",
                };
              }),
            }),
          );
          processedInvoices.sort((a, b) => b.id - a.id);
          setInvoices(processedInvoices);
          setTotalCount(
            parseApiPagination(response, processedInvoices.length).total,
          );
        } else {
          toast.error(response?.message || "Failed to fetch sales");
          setInvoices([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.error("Error fetching invoices:", error);
        setInvoices([]);
        setTotalCount(0);
      } finally {
        setLoading(false);
        isFetching.current = false;
      }
    },
    [quoteListScope],
  );

  const fetchInvoicesRef = useRef(fetchInvoices);
  fetchInvoicesRef.current = fetchInvoices;
  const banksFetchPromiseRef = useRef(null);

  const resetBankAccountsCache = () => {
    setBankAccounts({});
    setPaymentTypes([]);
    setBankAccountsList([]);
    setBankAccountsLoaded(false);
    banksFetchPromiseRef.current = null;
  };

  const fetchPaymentTypes = async () => {
    try {
      const response = await listBankAccounts();
      const rows = Array.isArray(response?.data?.bank_accounts)
        ? response.data.bank_accounts
        : [];

      if (response?.success && Array.isArray(rows)) {
        const fetchedBankDetails = rows.map((bank) => {
          // console.log("Bank record from API:", bank);

          return {
            id: bank.id,
            bankName: bank.bank_name || "",
            accountHolder: bank.holder_name || "",
            accountType: bank.account_type || "",
            ifscCode: bank.ifsc_code || bank.IFSC_code || "",
            accountNumber: bank.account_number || "",
            openingBalance: bank.opening_balance || "",
            balance: bank.opening_balance ? `₹${bank.opening_balance}` : "₹0",
            status: bank.status === 1 ? "Active" : "Inactive",
            statusClass:
              bank.status === 1
                ? "bg-success-subtle text-success"
                : "bg-danger-subtle text-danger",
            useForInvoice: bank.use_for_invoice === 1,
            useForPOS: bank.use_for_pos === 1,
          };
        });

        // Sort by ID in descending order (newest first)
        fetchedBankDetails.sort((a, b) => b.id - a.id);

        // Create a mapping object with bank ID as key and bank name as value
        const bankMapping = {};
        fetchedBankDetails.forEach((bank) => {
          bankMapping[bank.id] = bank.bankName;
        });

        setBankAccounts(bankMapping);
        const paymentOptions = fetchedBankDetails.map((bank) => ({
          value: bank.id,
          label: bank.bankName || "",
        }));
        setPaymentTypes(paymentOptions);
        const normalizedBanks = rows
          .map((bank) => ({
            id: bank.id,
            bank_name: bank.bank_name || bank.name || "",
            account_number: bank.account_number || "",
            account_type: bank.account_type || "",
            status: bank.status,
          }))
          .filter(
            (bank) =>
              bank.id != null &&
              bank.status !== 0 &&
              bank.status !== "0" &&
              String(bank.status || "").toLowerCase() !== "inactive",
          );
        normalizedBanks.sort((a, b) => Number(b.id) - Number(a.id));
        setBankAccountsList(normalizedBanks);
        setBankAccountsLoaded(true);
        // console.log("Bank accounts set successfully:", bankMapping);
      } else if (
        response.data &&
        response.data.message === "radha" &&
        (!response.data.data || response.data.data.length === 0)
      ) {
        // Handle empty data case
        // console.log("No bank accounts found");
        setBankAccounts({});
        setPaymentTypes([]);
        setBankAccountsLoaded(true);
        toast("No bank accounts found");
      } else if (response.data && response.data.success === false) {
        // Handle error case
        console.error("Server returned error:", response.data.message);
        setBankAccounts({});
        setPaymentTypes([]);
        setBankAccountsLoaded(true);
        toast.error(response.data.message || "Failed to fetch bank details");
      } else {
        // Handle unexpected format
        console.error("Unexpected data format:", response.data);
        setBankAccounts({});
        setPaymentTypes([]);
        setBankAccountsLoaded(true);
        toast.error("Unexpected response format from server");
      }
    } catch (error) {
      console.error("Error fetching bank details:", error);
      setBankAccounts({});
      setPaymentTypes([]);
      setBankAccountsLoaded(true);
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch bank details",
      );
    }
  };

  const ensurePaymentTypesLoaded = async () => {
    if (bankAccountsLoaded) return;
    if (banksFetchPromiseRef.current) {
      await banksFetchPromiseRef.current;
      return;
    }
    const promise = fetchPaymentTypes();
    banksFetchPromiseRef.current = promise;
    try {
      await promise;
    } finally {
      banksFetchPromiseRef.current = null;
    }
  };

  const fetchProductGroups = async () => {
    try {
      const response = await listProductGroups();
      const productGroupsData =
        response?.success && Array.isArray(response.data?.product_groups)
          ? response.data.product_groups
          : [];
      const fetchedGroups = productGroupsData.map((group) => ({
        id: group.id,
        name: group.name || "",
        metalGroupId: group.metal_group_id,
        shortCode: group.short_code || "",
      }));
      setProductGroups(fetchedGroups);
    } catch (error) {
      console.error("Error fetching product groups:", error);
    }
  };

  const fetchMetalGroups = async () => {
    try {
      const response = await listMetalGroups();
      const metalGroupsArray = Array.isArray(response?.data?.metal_groups)
        ? response.data.metal_groups
        : Array.isArray(response?.data?.records)
          ? response.data.records
          : [];

      if (response?.success && Array.isArray(metalGroupsArray)) {
        const metalGroupsMap = {};
        metalGroupsArray.forEach((group) => {
          metalGroupsMap[group.id] = {
            purity: group.purity || "",
            metal: group.metal || "",
            HSN_code: group.HSN_code || "",
          };
        });
        setMetalGroups(metalGroupsMap);
      }
    } catch (error) {
      console.error("Error fetching metal groups:", error);
    }
  };

  // Refetch whenever user lands on /invoice (e.g. after Save on Sales navigates here)
  useEffect(() => {
    if (location.pathname !== "/invoice") return;
    fetchInvoices(currentPage, itemsPerPage, searchQuery);
  }, [location.pathname, location.key]);

  useEffect(() => {
    const timeoutId = setTimeout(
      () => {
        fetchInvoices(currentPage, itemsPerPage, searchQuery);
      },
      searchQuery ? 200 : 0,
    );
    return () => clearTimeout(timeoutId);
  }, [currentPage, itemsPerPage, searchQuery, fetchInvoices]);

  // Navbar Quotation | All switch → refetch list type (list vs mixed)
  useEffect(() => {
    const handleScopeChange = (event) => {
      const next =
        event?.detail?.scope === "all"
          ? "all"
          : getQuoteInvoiceListScope();
      setQuoteListScope(next);
      setCurrentPage(1);
    };
    window.addEventListener(QUOTE_INVOICE_LIST_SCOPE_EVENT, handleScopeChange);
    return () => {
      window.removeEventListener(
        QUOTE_INVOICE_LIST_SCOPE_EVENT,
        handleScopeChange,
      );
    };
  }, []);

  // Listen for API URL changes and refetch data
  useEffect(() => {
    const handleApiUrlChange = (event) => {
      console.log(
        "API URL changed in Invoice, refetching invoices...",
        event.detail,
      );
      const nextPin =
        event?.detail?.pinType ||
        getCurrentPinType() ||
        localStorage.getItem("currentPinType") ||
        "access";
      setPinType(nextPin);
      resetBankAccountsCache();
      setCurrentPage(1);
      fetchInvoices(1, itemsPerPage, searchQuery);
    };

    window.addEventListener("apiUrlChanged", handleApiUrlChange);

    return () => {
      window.removeEventListener("apiUrlChanged", handleApiUrlChange);
    };
  }, [itemsPerPage, searchQuery, fetchInvoices]);

  // After Sales save: refetch if socket event name/shape doesn't match backend
  useEffect(() => {
    const onInvalidate = () => {
      fetchInvoicesRef.current(currentPage, itemsPerPage, searchQuery);
    };
    window.addEventListener(ERP_SALES_LIST_INVALIDATE_EVENT, onInvalidate);
    return () =>
      window.removeEventListener(ERP_SALES_LIST_INVALIDATE_EVENT, onInvalidate);
  }, [currentPage, itemsPerPage, searchQuery]);

  // Socket.IO listener for real-time invoice updates
  useEffect(() => {
    const newSocket = createErpSocket();
    setSocket(newSocket);

    // Connection event logging
    newSocket.on("connect", () => {
      // console.log("Invoice: Connected to socket server", newSocket.id);
    });

    newSocket.on("disconnect", (reason) => {
      // console.log("Invoice: Disconnected from socket server:", reason);
    });

    newSocket.on("connect_error", (error) => {
      console.error("Invoice: Socket connection error:", error);
    });

    const handleSaleCreatedLike = (payload) => {
      const raw =
        payload?.sale ??
        payload?.invoice ??
        payload?.data?.sale ??
        payload?.data?.invoice ??
        (payload?.id != null ? payload : null);
      if (!raw) return;
      const processedInvoice = mapSocketSaleToInvoiceRow(raw);
      if (!processedInvoice?.id) return;

      setInvoices((prev) => {
        const existingIndex = prev.findIndex(
          (invoice) => invoice.id === processedInvoice.id,
        );
        if (existingIndex !== -1) return prev;
        setTotalCount((c) => c + 1);
        return [processedInvoice, ...prev];
      });
    };

    newSocket.on("sale_created", handleSaleCreatedLike);
    newSocket.on("invoice_created", handleSaleCreatedLike);
    newSocket.on("sales_created", handleSaleCreatedLike);

    newSocket.on("sale_updated", (data) => {
      if (!data?.sale) return;

      const updatedSale = data.sale;

      setInvoices((prev) =>
        prev.map((invoice) =>
          invoice.id === updatedSale.id
            ? {
              ...invoice,
              voucherNumber:
                updatedSale.voucher_number || invoice.voucherNumber,
              userId:
                updatedSale.user_id ||
                updatedSale.customer_id ||
                invoice.userId,
              customerName: updatedSale.name || invoice.customerName,
              customerMobile: updatedSale.mobile || invoice.customerMobile,
              byUser: updatedSale.by_user ?? invoice.byUser,
              byUserName:
                updatedSale.by_user_name != null &&
                  String(updatedSale.by_user_name).trim() !== ""
                  ? String(updatedSale.by_user_name).trim()
                  : invoice.byUserName,
              totalItems: updatedSale.sales
                ? updatedSale.sales.length
                : invoice.totalItems,
              grandTotal: updatedSale.grand_total || invoice.grandTotal,
              final_amount:
                updatedSale.final_amount ||
                updatedSale.grand_total ||
                invoice.final_amount,
              remainingAmount:
                updatedSale.remaining_amount || invoice.remainingAmount,
              status:
                updatedSale.status !== undefined
                  ? normalizeInvoiceTableStatus(updatedSale.status)
                  : invoice.status,
              round_off: updatedSale.round_off || invoice.round_off,
              note:
                updatedSale.note !== undefined
                  ? updatedSale.note
                  : invoice.note,
              items: updatedSale.sales || invoice.items,
              payments: updatedSale.payments || invoice.payments,
              followup_date:
                updatedSale.followup_date !== undefined
                  ? updatedSale.followup_date
                  : invoice.followup_date,
              discount: updatedSale.discount || invoice.discount,
              discount_amount:
                updatedSale.discount_amount || invoice.discount_amount,
              gst_percent: updatedSale.gst_percent || invoice.gst_percent,
              gst_amount: updatedSale.gst_amount || invoice.gst_amount,
              sgst: updatedSale.sgst || invoice.sgst,
              cgst: updatedSale.cgst || invoice.cgst,
              igst: updatedSale.igst || invoice.igst,
              repairing_id:
                updatedSale.repairing_id !== undefined
                  ? updatedSale.repairing_id
                  : invoice.repairing_id,
            }
            : invoice,
        ),
      );
    });

    newSocket.on("sales_details_updated", (data) => {
      if (!data?.sale) return;

      const updatedSale = data.sale;

      setInvoices((prev) =>
        prev.map((invoice) =>
          invoice.id === updatedSale.id
            ? {
              ...invoice,
              voucherNumber:
                updatedSale.voucher_number || invoice.voucherNumber,
              userId:
                updatedSale.user_id ||
                updatedSale.customer_id ||
                invoice.userId,
              customerName: updatedSale.name || invoice.customerName,
              customerMobile: updatedSale.mobile || invoice.customerMobile,
              byUser: updatedSale.by_user ?? invoice.byUser,
              byUserName:
                updatedSale.by_user_name != null &&
                  String(updatedSale.by_user_name).trim() !== ""
                  ? String(updatedSale.by_user_name).trim()
                  : invoice.byUserName,
              totalItems: updatedSale.sales
                ? updatedSale.sales.length
                : invoice.totalItems,
              grandTotal: updatedSale.grand_total || invoice.grandTotal,
              final_amount:
                updatedSale.final_amount ||
                updatedSale.grand_total ||
                invoice.final_amount,
              remainingAmount:
                updatedSale.remaining_amount || invoice.remainingAmount,
              status:
                updatedSale.status !== undefined
                  ? normalizeInvoiceTableStatus(updatedSale.status)
                  : invoice.status,
              round_off: updatedSale.round_off || invoice.round_off,
              note:
                updatedSale.note !== undefined
                  ? updatedSale.note
                  : invoice.note,
              items: updatedSale.sales || invoice.items,
              payments: updatedSale.payments || invoice.payments,
              followup_date:
                updatedSale.followup_date !== undefined
                  ? updatedSale.followup_date
                  : invoice.followup_date,
              discount: updatedSale.discount || invoice.discount,
              discount_amount:
                updatedSale.discount_amount || invoice.discount_amount,
              gst_percent: updatedSale.gst_percent || invoice.gst_percent,
              gst_amount: updatedSale.gst_amount || invoice.gst_amount,
              sgst: updatedSale.sgst || invoice.sgst,
              cgst: updatedSale.cgst || invoice.cgst,
              igst: updatedSale.igst || invoice.igst,
              repairing_id:
                updatedSale.repairing_id !== undefined
                  ? updatedSale.repairing_id
                  : invoice.repairing_id,
            }
            : invoice,
        ),
      );
    });

    return () => {
      newSocket.off("sale_created");
      newSocket.off("invoice_created");
      newSocket.off("sales_created");
      newSocket.off("sale_updated");
      newSocket.off("sales_details_updated");
      newSocket.disconnect();
    };
  }, []);

  // Client-side status filter on the current server page
  const filteredInvoices = invoices.filter((invoice) => {
    const st = String(invoice.status ?? "");
    const matchesStatus =
      statusFilter === "" ||
      (statusFilter === "Active" &&
        (st === "1" || invoice.status === 1) &&
        st !== "3" &&
        invoice.status !== 3) ||
      (statusFilter === "Paid" &&
        parseFloat(invoice.remainingAmount) === 0 &&
        invoice.status !== "3" &&
        invoice.status !== 3) ||
      (statusFilter === "Pending" &&
        parseFloat(invoice.remainingAmount) ===
        parseFloat(invoice.grandTotal) &&
        invoice.status !== "3" &&
        invoice.status !== 3) ||
      (statusFilter === "Partially Paid" &&
        parseFloat(invoice.remainingAmount) > 0 &&
        parseFloat(invoice.remainingAmount) < parseFloat(invoice.grandTotal) &&
        invoice.status !== "3" &&
        invoice.status !== 3) ||
      (statusFilter === "Return" &&
        (invoice.status === "3" || invoice.status === 3));

    return matchesStatus;
  });

  const displayedInvoices = filteredInvoices;

  // Pagination logic
  const handlePageChange = (newPage) => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };

  // Handle checkbox selection
  const handleCheckboxChange = (itemId) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.includes(itemId)) {
        return prevSelected.filter((id) => id !== itemId);
      } else {
        return [...prevSelected, itemId];
      }
    });
  };

  // Handle select all checkbox
  const handleSelectAll = () => {
    if (selectedItems.length === displayedInvoices.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(displayedInvoices.map((item) => item.id));
    }
  };

  // Add numberToWords function here, before pdfContent
  const numberToWords = (num) => {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    if (num === 0) return "Zero";

    const convertLessThanThousand = (n) => {
      if (n === 0) return "";
      if (n < 10) return ones[n];
      if (n < 20) return teens[n - 10];
      if (n < 100)
        return (
          tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
        );
      return (
        ones[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 !== 0 ? " and " + convertLessThanThousand(n % 100) : "")
      );
    };

    const convert = (n) => {
      if (n === 0) return "";
      if (n < 1000) return convertLessThanThousand(n);
      if (n < 100000)
        return (
          convertLessThanThousand(Math.floor(n / 1000)) +
          " Thousand" +
          (n % 1000 !== 0 ? " " + convertLessThanThousand(n % 1000) : "")
        );
      if (n < 10000000)
        return (
          convertLessThanThousand(Math.floor(n / 100000)) +
          " Lakh" +
          (n % 100000 !== 0 ? " " + convert(n % 100000) : "")
        );
      return (
        convertLessThanThousand(Math.floor(n / 10000000)) +
        " Crore" +
        (n % 10000000 !== 0 ? " " + convert(n % 10000000) : "")
      );
    };

    return convert(Math.floor(num));
  };

  // Add date formatting function
  function formatDate(dateString) {
    if (!dateString) return "";
    if (/^\d{2}-\d{2}-\d{4}$/.test(String(dateString))) {
      return String(dateString);
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(String(dateString))) {
      const [year, month, day] = String(dateString).split("-");
      return `${day}-${month}-${year}`;
    }
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return String(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  function formatTime(dateString) {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return null;
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${ampm}`;
  }

  function formatSaleListDateCell(invoice) {
    const dateStr = formatDate(
      invoice.doc_date || invoice.creationDate || invoice.date,
    );
    const timeStr = formatTime(invoice.created_at);
    if (!dateStr && !timeStr) return "-";
    return (
      <>
        {dateStr ? <div>{dateStr}</div> : null}
        {timeStr ? <div>{timeStr}</div> : null}
      </>
    );
  }

  function formatDateTime(dateString) {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return null;
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return (
      <>
        <div>{`${day}-${month}-${year}`}</div>
        <div>{`${hours}:${minutes} ${ampm}`}</div>
      </>
    );
  }

  const toNumberOrZero = (value) => {
    const numeric = parseFloat(value);
    return Number.isFinite(numeric) ? numeric : 0;
  };

  const normalizePdfCharge = (charge = {}) => ({
    ...charge,
    charge_type:
      charge.charge_type || charge.chargeType || charge.type || "",
    ct: charge.ct ?? charge.charge_ct ?? 0,
    wt:
      charge.wt ??
      charge.weight ??
      charge.wtTotal ??
      charge.wt_total ??
      0,
    pcs: charge.pcs ?? charge.count ?? 0,
    rate_on: charge.rate_on || charge.rateOn || "",
    rate: charge.rate ?? 0,
    amount: charge.amount ?? charge.amt ?? 0,
  });

  const normalizePdfItem = (item = {}) => {
    const rawName = item.item_category_name || "";

    return {
      id: item.id ?? item.product_id ?? item.tag_no ?? "",
      name: rawName,
      issueDescription:
        item.issueDescription ||
        item.issue_description ||
        item.description ||
        "",
      purity: item.purity || item.metal_purity || item.product_purity || "",
      hsn: item.hsn || item.HSN_code || item.hsn_code || "7113",
      grossWeight:
        item.gwt ?? item.grossWeight ?? item.gross_weight ?? "0.0000",
      netWeight: item.nwt ?? item.netWeight ?? item.net_weight ?? "0.0000",
      rate: item.item_rate ?? item.itrate ?? item.rate ?? "0.00",
      othamt: item.oth_amt ?? item.othamt ?? item.other_amount ?? "0.00",
      amount:
        item.total_amount ??
        item.totalamt ??
        item.item_amount ??
        item.amount ??
        "0.00",
      charges: Array.isArray(item.charges)
        ? item.charges.map(normalizePdfCharge)
        : [],
      lbr_type: item.lbr_type || "",
      lbr_percent: item.lbr_percent || "0.00",
      lbr_rate: item.lbr_rate || "0.00",
      lbr_amt: item.lbr_amt || "0.00",
      carat: item.carat || "",
      tag_no: item.tag_no || item.tagNo || item.tag || "",
      huid: item.huid || "",
    };
  };

  const normalizePdfCustomer = (invoice = {}, user = {}) => ({
    name:
      invoice.customer_name ||
      invoice.name ||
      invoice.customerDetails?.name ||
      user.name ||
      "",
    mobile:
      invoice.customer_mobile ||
      invoice.mobile ||
      invoice.customerDetails?.mobile ||
      user.mobile ||
      "",
    address:
      invoice.customer_address ||
      invoice.address ||
      invoice.customerDetails?.address ||
      user.address ||
      "",
    city:
      invoice.customer_city ||
      invoice.city ||
      invoice.customerDetails?.city ||
      user.city ||
      "",
    state:
      invoice.customer_state ||
      invoice.state ||
      invoice.customerDetails?.state ||
      user.state ||
      "",
    GST_number:
      invoice.customer_gst_number ||
      invoice.gst_number ||
      invoice.customerDetails?.gst_number ||
      user.GST_number ||
      "",
    pan_no:
      invoice.customer_pan_no ||
      invoice.pan_no ||
      invoice.customerDetails?.pan_no ||
      user.pan_no ||
      "",
    aadhar_no:
      invoice.customer_aadhar_no ||
      invoice.aadhar_no ||
      invoice.customerDetails?.aadhar_no ||
      user.aadhar_no ||
      "",
  });

  const normalizePdfInvoice = (invoice = {}, user = {}) => {
    const items = Array.isArray(invoice.items)
      ? invoice.items
      : Array.isArray(invoice.sales)
        ? invoice.sales
        : [];
    const totalAmount = toNumberOrZero(
      invoice.total_amount ?? invoice.final_amount ?? invoice.totalAmount,
    );
    const grandTotal = toNumberOrZero(
      invoice.grand_total ?? invoice.grandTotal ?? invoice.total_amount,
    );
    const remainingAmount = toNumberOrZero(
      invoice.remaining_amount ?? invoice.remainingAmount,
    );
    const paidAmount = toNumberOrZero(
      invoice.paid_amount ?? invoice.paidAmount ?? grandTotal - remainingAmount,
    );
    const taxAmount = toNumberOrZero(
      invoice.tax_amount ?? invoice.gst_amount ?? invoice.totalTax,
    );
    const gstPercent = toNumberOrZero(invoice.gst_percent ?? 0);
    const sgst = toNumberOrZero(invoice.sgst ?? 0);
    const cgst = toNumberOrZero(invoice.cgst ?? 0);
    const igst = toNumberOrZero(invoice.igst ?? 0);
    const normalizedOldPurchase = Array.isArray(invoice.old_purchase)
      ? invoice.old_purchase
      : Array.isArray(invoice.old_purchase_details)
        ? invoice.old_purchase_details
        : [];
    const normalizedPayments = Array.isArray(invoice.payments)
      ? invoice.payments
      : [];

    return {
      invoiceNumber:
        invoice.doc_number ||
        invoice.voucherNumber ||
        invoice.voucher_number ||
        "",
      date: formatDate(
        invoice.doc_date || invoice.creationDate || invoice.date,
      ),
      customer: normalizePdfCustomer(invoice, user),
      items: items.map(normalizePdfItem),
      final_amount: totalAmount.toFixed(2),
      subtotal: totalAmount.toFixed(2),
      gst_percent: gstPercent.toFixed(2),
      sgst: sgst.toFixed(2),
      cgst: cgst.toFixed(2),
      igst: igst.toFixed(2),
      gst_amount: taxAmount.toFixed(2),
      totalTax: taxAmount.toFixed(2),
      grandTotal: grandTotal.toFixed(2),
      amountInWords: `Rupees ${numberToWords(grandTotal)} Only`,
      round_off: (invoice.round_off ?? 0).toString(),
      note: invoice.notes || invoice.note || "",
      paidAmount: paidAmount.toFixed(2),
      remainingAmount:
        invoice.remaining_amount != null || invoice.remainingAmount != null
          ? remainingAmount.toFixed(2)
          : Math.max(0, grandTotal - paidAmount).toFixed(2),
      payments: normalizedPayments,
      old_purchase: normalizedOldPurchase,
      payable_amount: invoice.payable_amount ?? invoice.payableAmount ?? 0,
      sale_payable:
        invoice.sale_payable ?? invoice.salePayable ?? invoice.payables ?? [],
      followup_date: invoice.followup_date || "",
      discount: invoice.discount || "0.00",
      discount_amount: invoice.discount_amount || invoice.discount || "0.00",
      bankAccounts,
      signed_qr_image: invoice.signed_qr_image || "",
      ...resolveSaleEinvoiceFields(invoice),
    };
  };

  const handlePdfSizeSelect = (size) => {
    setShowPdfSizeModal(false);
    if (size === "Cover") {
      setShowCoverModal(true);
      return;
    }
    setPdfPaperSize(size);
    setShowPdfModal(true);
  };

  const PdfDocument =
    pdfPaperSize === "A5"
      ? isQuoteMode
        ? QuoteA5
        : InvoicePDFA5
      : isQuoteMode
        ? QuoteInvoiceA4
        : InvoicePDF;

  const coverDataList = useMemo(() => {
    if (!selectedInvoicesForPdf.length) return [];
    return selectedInvoicesForPdf.map((item) => {
      const customer = normalizePdfCustomer(item.invoice, item.user);
      return {
        name: customer.name,
        address: customer.address,
        city: customer.city,
        mobile: customer.mobile,
        customer,
        invoice: item.invoice,
      };
    });
  }, [selectedInvoicesForPdf]);

  // Memoize the PDF content
  const pdfContent = useMemo(() => {
    if (!selectedInvoicesForPdf.length) return null;

    return selectedInvoicesForPdf.map((item, index) => {
      const invoiceData = normalizePdfInvoice(item.invoice, item.user);

      return (
        <div
          key={item.invoice.id}
          style={{
            height: "100%",
            marginBottom:
              index < selectedInvoicesForPdf.length - 1 ? "20px" : "0",
          }}
        >
          {index > 0 && <hr />}
          <PDFViewer
            width="100%"
            height={index === 0 ? "100%" : "500px"}
            key={`pdf-viewer-${item.invoice.id}-${pdfPaperSize}`}
          >
            <PdfDocument invoiceData={invoiceData} />
          </PDFViewer>
        </div>
      );
    });
  }, [selectedInvoicesForPdf, bankAccounts, pdfPaperSize]);

  const coverPdfContent = useMemo(() => {
    if (!coverDataList.length) return null;
    return <InvoiceCoverPDF covers={coverDataList} />;
  }, [coverDataList]);

  /** Download A4 with letter-pad background; preview stays without it */
  const handleDownloadPdfWithLetterPad = async () => {
    if (!selectedInvoicesForPdf.length) return;
    try {
      const item = selectedInvoicesForPdf[0];
      const invoiceData = normalizePdfInvoice(item.invoice, item.user);
      if (invoiceData.signed_qr_code) {
        invoiceData.signed_qr_image = await buildSignedQrDataUrl(
          invoiceData.signed_qr_code,
        );
      }
      const isQuote = getCurrentPinType() === "quote";
      const Doc =
        pdfPaperSize === "A5"
          ? isQuote
            ? QuoteA5
            : InvoicePDFA5
          : isQuote
            ? QuoteInvoiceA4
            : InvoicePDF;
      const blob = await pdf(
        <Doc
          invoiceData={invoiceData}
          embedLetterhead={pdfPaperSize === "A4"}
        />,
      ).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `invoice_${invoiceData.invoiceNumber || item.invoice.id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("PDF download failed:", err);
      toast.error("Failed to download PDF");
    }
  };

  const buildInvoiceWithDetails = async (inv) => {
    try {
      const res = await showSale({ id: inv.id });
      const saleDetails = getLegacySaleDetailsFromShowResponse(res);
      if (saleDetails) {
        const processedItems = saleDetails.sales
          ? saleDetails.sales.map((it) => {
            const productGroup = productGroups.find(
              (pg) =>
                pg.id === it.product_group ||
                pg.id === it.product_group_id ||
                pg.name === it.product_group,
            );
            const metalGroup = productGroup
              ? metalGroups[productGroup.metalGroupId]
              : null;
            return {
              ...it,
              item_category_name: it.item_category_name || "",
              carat: it.carat || "",
              productGroupName:
                it.product_group ||
                (productGroup ? productGroup.name : "N/A"),
              purity:
                it.metal_purity || (metalGroup ? metalGroup.purity : "N/A"),
              metal:
                it.metal_group_name ||
                (metalGroup ? metalGroup.metal : "N/A"),
              hsn:
                it.hsn ||
                (metalGroup && metalGroup.HSN_code
                  ? metalGroup.HSN_code
                  : ""),
            };
          })
          : [];
        const processedPayments = saleDetails.payments
          ? saleDetails.payments.map((p) => {
            const isUrd =
              isUrdLinkedPaymentMode(p?.payment_mode) ||
              Number(p?.urd_document_id) > 0;
            return {
              ...p,
              bank_name: isUrd
                ? formatApiPaymentDisplayLabel(p)
                : p.bank_name || bankAccounts[p.bank_type] || "Unknown Bank",
            };
          })
          : [];
        const enriched = {
          ...inv,
          items: processedItems,
          payments: processedPayments,
          voucherNumber: saleDetails.voucher_number || inv.voucherNumber,
          creationDate: saleDetails.date || inv.creationDate,
          userId: saleDetails.user_id || inv.userId,
          final_amount: saleDetails.final_amount || inv.final_amount,
          grandTotal: saleDetails.grand_total || inv.grandTotal,
          round_off: saleDetails.round_off || inv.round_off,
          remainingAmount: saleDetails.remaining_amount || inv.remainingAmount,
          payable_amount:
            saleDetails.payable_amount ??
            saleDetails.payableAmount ??
            inv.payable_amount ??
            0,
          sale_payable:
            saleDetails.sale_payable ??
            saleDetails.salePayable ??
            inv.sale_payable ??
            [],
          discount: saleDetails.discount || inv.discount,
          discount_amount: saleDetails.discount_amount || inv.discount_amount,
          note: saleDetails.note || inv.note,
          followup_date: saleDetails.followup_date || inv.followup_date,
          gst_percent: saleDetails.gst_percent || inv.gst_percent,
          gst_amount: saleDetails.gst_amount || inv.gst_amount,
          sgst: saleDetails.sgst || inv.sgst,
          cgst: saleDetails.cgst || inv.cgst,
          igst: saleDetails.igst || inv.igst,
          old_purchase:
            saleDetails.old_purchase ||
            saleDetails.old_purchase_details ||
            inv.old_purchase ||
            [],
          customerDetails: {
            name: saleDetails.name,
            mobile: saleDetails.mobile,
            address: saleDetails.address,
            city: saleDetails.city,
            state: saleDetails.state,
            aadhar_no:
              saleDetails.aadhar_no ||
              saleDetails.userss?.aadhar_no ||
              "",
            pan_no:
              saleDetails.pan_no ||
              saleDetails.userss?.pan_no ||
              "",
            gst_number:
              saleDetails.GST_number ||
              saleDetails.userss?.GST_number ||
              "",
            company_name: saleDetails.userss?.company_name || "",
            company_address: saleDetails.userss?.company_address || "",
          },
          userss: saleDetails.userss || inv.userss || null,
          gst_portal:
            saleDetails.gst_portal ??
            inv.gst_portal ??
            saleDetails.gstPortal ??
            inv.gstPortal ??
            null,
          ...resolveSaleEinvoiceFields({ ...inv, ...saleDetails }),
        };
        // console.log("Invoice.jsx → enriched sale details", {
        //   id: enriched.id,
        //   gst_percent: enriched.gst_percent,
        //   sgst: enriched.sgst,
        //   cgst: enriched.cgst,
        //   igst: enriched.igst,
        //   gst_amount: enriched.gst_amount,
        // });
        return enriched;
      }
    } catch (err) { }
    return inv;
  };

  const resetSettlementModalState = () => {
    setSettlementRows(createDefaultSettlementRows());
    setExistingSettlementPayments([]);
    setSettlementInvoiceDetails(null);
    setSelectedInvoiceForSettlement(null);
    setIsSettlementLoading(false);
    setIsSettlementSaving(false);
    setIsPreviousPaymentsExpanded(false);
  };

  const handleOpenSettlementModal = async (invoice) => {
    const remaining = parseNumericValue(invoice.remainingAmount);
    if (remaining <= 0 || invoice.status === "3" || invoice.status === 3) {
      return;
    }

    setSelectedInvoiceForSettlement(invoice);
    setSettlementRows(createDefaultSettlementRows());
    setExistingSettlementPayments([]);
    setSettlementInvoiceDetails(null);
    setShowSettlementModal(true);
    setIsSettlementLoading(true);

    try {
      const [, res] = await Promise.all([
        ensurePaymentTypesLoaded(),
        showSale({ id: invoice.id }),
      ]);

      if (isSalesApiSuccess(res)) {
        const saleDetails = getLegacySaleDetailsFromShowResponse(res);
        if (saleDetails) {
          setSettlementInvoiceDetails(saleDetails);
          setExistingSettlementPayments(saleDetails.payments || []);
        } else {
          toast.error("Unable to load invoice details");
          setShowSettlementModal(false);
          resetSettlementModalState();
        }
      } else {
        toast.error(res?.message || "Failed to load invoice details");
        setShowSettlementModal(false);
        resetSettlementModalState();
      }
    } catch (error) {
      console.error("Error fetching sale details:", error);
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Failed to load invoice details",
      );
      setShowSettlementModal(false);
      resetSettlementModalState();
    } finally {
      setIsSettlementLoading(false);
    }
  };

  const handleCloseSettlementModal = () => {
    if (isSettlementSaving) {
      return;
    }
    setShowSettlementModal(false);
    resetSettlementModalState();
  };

  const handleSaveSettlement = async ({ print = false } = {}) => {
    if (!settlementInvoiceDetails || !selectedInvoiceForSettlement) {
      toast.error("Invoice details are not available");
      return;
    }

    if (isSettlementLoading || isSettlementSaving) {
      return;
    }

    const newPayments = settlementRows
      .filter((row) => row.pay_mode && parseNumericValue(row.amount) > 0)
      .map((row) => ({
        pay_mode_key: row.pay_mode,
        pay_mode: SETTLEMENT_METHOD_LABELS[row.pay_mode] || row.pay_mode || "",
        bank_type: row.pay_mode === "kasar" ? "" : row.type || "",
        remarks: row.remarks || "",
        amt: parseNumericValue(row.amount),
      }));

    if (newPayments.length === 0) {
      toast.error("Enter at least one amount to settle");
      return;
    }

    const baseRemaining = settlementRemainingAmount;
    const additionalAmount = newPayments.reduce(
      (sum, payment) => sum + parseNumericValue(payment.amt),
      0,
    );

    if (additionalAmount - baseRemaining > 0.05) {
      toast.error("Settlement amount exceeds remaining balance");
      return;
    }

    setIsSettlementSaving(true);

    try {
      const saleDetails = settlementInvoiceDetails;

      if (!settlementIdempotencyKeyRef.current) {
        settlementIdempotencyKeyRef.current = createSalesIdempotencyKey();
      }

      const erpPayments = newPayments
        .map((p) => {
          const remarks = p.remarks?.trim() ? p.remarks.trim() : null;
          if (p.pay_mode_key === "kasar") {
            return {
              payment_mode: "Kasar",
              amount: Number(p.amt) || 0,
              remarks,
            };
          }
          return {
            bank_account_id: Number(p.bank_type) || undefined,
            amount: Number(p.amt) || 0,
            payment_mode: p.pay_mode || null,
            remarks,
          };
        })
        .filter((p) => p.amount > 0);

      const response = await settlementSale({
        sale_id: saleDetails.id,
        idempotency_key: settlementIdempotencyKeyRef.current,
        payments: erpPayments,
      });

      if (isSalesApiSuccess(response)) {
        settlementIdempotencyKeyRef.current = null;
        toast.success("Amount settled successfully");

        if (print) {
          const customer = saleDetails.customerDetails || {};
          const modeParts = [
            ...new Set(
              newPayments
                .map((p) => p.pay_mode)
                .filter((m) => m && String(m).trim()),
            ),
          ];
          const remarksParts = newPayments
            .map((p) => (p.remarks || "").trim())
            .filter(Boolean);
          const voucherNo =
            saleDetails.voucher_number ||
            selectedInvoiceForSettlement?.voucherNumber ||
            saleDetails.id ||
            "-";

          setSettlementVoucherData(
            buildJamaVoucherData({
              isIn: true,
              party: {
                name:
                  customer.name ||
                  saleDetails.name ||
                  selectedInvoiceForSettlement?.customerName ||
                  "",
                mobile: customer.mobile || saleDetails.mobile || "",
                address: customer.address || saleDetails.address || "",
                city: customer.city || saleDetails.city || "",
                gst:
                  customer.gst_number ||
                  saleDetails.GST_number ||
                  saleDetails.gst_number ||
                  "",
              },
              amount: additionalAmount,
              balance: baseRemaining,
              date: new Date().toISOString().split("T")[0],
              remarks: remarksParts.join("; "),
              paymentModeLabel: modeParts.join(" + ") || "Cash",
              apiResponse: {
                data: {
                  ...(response?.data || {}),
                  voucher_number: voucherNo,
                },
              },
            }),
          );
          setShowSettlementVoucherPreview(true);
        }

        setShowSettlementModal(false);
        resetSettlementModalState();
        fetchInvoices(currentPage, itemsPerPage, searchQuery);
      } else {
        toast.error(response?.message || "Failed to save settlement details");
      }
    } catch (error) {
      console.error("Error saving settlement:", error);
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Failed to save settlement",
      );
    } finally {
      setIsSettlementSaving(false);
    }
  };

  // Handle bulk actions for selected items
  const handleBulkAction = async (action) => {
    if (action === "edit") {
      const selectedInvoiceData = displayedInvoices
        .filter((invoice) => selectedItems.includes(invoice.id))
        .map((invoice) => ({
          id: invoice.id,
          voucherNumber: invoice.voucherNumber,
        }));

      // console.log("Selected Invoice IDs for edit:", selectedItems);
      // console.log("Selected Invoice Data:", selectedInvoiceData);

      navigate("/editinvoice", {
        state: {
          selectedItemIds: selectedItems,
          selectedInvoices: selectedInvoiceData,
        },
      });
    } else if (action === "export-to-pdf") {
      await ensurePaymentTypesLoaded();
      const selectedInvoicesData = displayedInvoices
        .filter((invoice) => selectedItems.includes(invoice.id))
        .map((invoice) => ({
          invoice,
          user: {
            name: invoice.customerName || "N/A",
            mobile: invoice.customerMobile || "N/A",
            email: "",
            state: "0",
            city: "",
            address: "",
            aadhar_no: "",
            pan_no: "",
            GST_number: "",
            company_name: "",
            company_address: "",
            reference: "",
            status: "1",
          },
        }));

      // Generate PDF and download directly
      const A4InvoiceDoc =
        getCurrentPinType() === "quote" ? QuoteInvoiceA4 : InvoicePDF;
      const pdfDoc = await pdf(
        <A4InvoiceDoc
          embedLetterhead
          invoiceData={{
            invoiceNumber: selectedInvoicesData[0].invoice.voucherNumber,
            date: formatDate(selectedInvoicesData[0].invoice.creationDate),
            customer: selectedInvoicesData[0].user,
            items: selectedInvoicesData[0].invoice.items.map((item, idx) => ({
              id: idx + 1,
              name: item.productGroupName,
              issueDescription: item.issueDescription || "",
              purity: item.purity,
              hsn: item.hsn || "7113",
              grossWeight: item.gwt || "0.000",
              netWeight: item.nwt || "0.000",
              rate: item.itrate || "0.00",
              othamt: item.othamt || "0.00",
              amount: item.totalamt || "0.00",
              tag_no: item.tag_no || item.tagNo || item.tag || "",
              huid:
                item.huid ||
                item.HUID ||
                item.tag_no ||
                item.tagNo ||
                item.tag ||
                "",
            })),
            final_amount:
              selectedInvoicesData[0].invoice.final_amount || "0.00",
            subtotal: selectedInvoicesData[0].invoice.grandTotal,
            gst_percent: selectedInvoicesData[0].invoice.gst_percent || "0.00",
            sgst: selectedInvoicesData[0].invoice.sgst || "0.00",
            cgst: selectedInvoicesData[0].invoice.cgst || "0.00",
            igst: selectedInvoicesData[0].invoice.igst || "0.00",
            totalTax: (
              parseFloat(selectedInvoicesData[0].invoice.gst_amount) * 0.03
            ).toFixed(2),
            grandTotal: selectedInvoicesData[0].invoice.grandTotal,
            amountInWords:
              "Rupees " +
              numberToWords(
                parseFloat(selectedInvoicesData[0].invoice.grandTotal),
              ) +
              " Only",
            round_off: selectedInvoicesData[0].invoice.round_off || "0.00",
            note: selectedInvoicesData[0].invoice.note || "",
            paidAmount: (
              parseFloat(selectedInvoicesData[0].invoice.grandTotal) -
              parseFloat(selectedInvoicesData[0].invoice.remainingAmount)
            ).toFixed(2),
            remainingAmount: selectedInvoicesData[0].invoice.remainingAmount,
            payments: selectedInvoicesData[0].invoice.payments || [],
            old_purchase: selectedInvoicesData[0].invoice.old_purchase || [],
            sale_payable:
              selectedInvoicesData[0].invoice.sale_payable ??
              selectedInvoicesData[0].invoice.salePayable ??
              [],
            bankAccounts: bankAccounts,
          }}
        />,
      ).toBlob();

      // Create download link and trigger download
      const url = URL.createObjectURL(pdfDoc);
      const link = document.createElement("a");
      link.href = url;
      link.download = `invoice_${selectedInvoicesData[0].invoice.voucherNumber}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } else if (action === "print") {
      await ensurePaymentTypesLoaded();
      const selectedInvoicesData = displayedInvoices
        .filter((invoice) => selectedItems.includes(invoice.id))
        .map((invoice) => ({
          invoice,
          user: {
            name: invoice.customerName || "N/A",
            mobile: invoice.customerMobile || "N/A",
          },
        }));

      // Generate PDF and convert to blob
      const A4InvoiceDoc =
        getCurrentPinType() === "quote" ? QuoteInvoiceA4 : InvoicePDF;
      const pdfDoc = await pdf(
        <A4InvoiceDoc
          invoiceData={{
            invoiceNumber: selectedInvoicesData[0].invoice.voucherNumber,
            date: formatDate(selectedInvoicesData[0].invoice.creationDate),
            customer: selectedInvoicesData[0].user,
            items: selectedInvoicesData[0].invoice.items.map((item, idx) => ({
              id: idx + 1,
              name: item.productGroupName,
              issueDescription: item.issueDescription || "",
              purity: item.purity,
              hsn: item.hsn || "7113",
              grossWeight: item.gwt || "0.000",
              netWeight: item.nwt || "0.000",
              rate: item.itrate || "0.00",
              othamt: item.othamt || "0.00",
              amount: item.totalamt || "0.00",
              tag_no: item.tag_no || item.tagNo || item.tag || "",
              huid:
                item.huid ||
                item.HUID ||
                item.tag_no ||
                item.tagNo ||
                item.tag ||
                "",
            })),
            final_amount:
              selectedInvoicesData[0].invoice.final_amount || "0.00",
            subtotal: selectedInvoicesData[0].invoice.grandTotal,
            gst_percent: selectedInvoicesData[0].invoice.gst_percent || "0.00",
            sgst: selectedInvoicesData[0].invoice.sgst || "0.00",
            cgst: selectedInvoicesData[0].invoice.cgst || "0.00",
            igst: selectedInvoicesData[0].invoice.igst || "0.00",
            totalTax: (
              parseFloat(selectedInvoicesData[0].invoice.gst_amount) * 0.03
            ).toFixed(2),
            grandTotal: selectedInvoicesData[0].invoice.grandTotal,
            amountInWords:
              "Rupees " +
              numberToWords(
                parseFloat(selectedInvoicesData[0].invoice.grandTotal),
              ) +
              " Only",
            round_off: selectedInvoicesData[0].invoice.round_off || "0.00",
            note: selectedInvoicesData[0].invoice.note || "",
            paidAmount: (
              parseFloat(selectedInvoicesData[0].invoice.grandTotal) -
              parseFloat(selectedInvoicesData[0].invoice.remainingAmount)
            ).toFixed(2),
            remainingAmount: selectedInvoicesData[0].invoice.remainingAmount,
            payments: selectedInvoicesData[0].invoice.payments || [],
            old_purchase: selectedInvoicesData[0].invoice.old_purchase || [],
            sale_payable:
              selectedInvoicesData[0].invoice.sale_payable ??
              selectedInvoicesData[0].invoice.salePayable ??
              [],
            bankAccounts: bankAccounts,
          }}
        />,
      ).toBlob();

      // Create a temporary iframe to display the PDF
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      document.body.appendChild(iframe);

      // Load the PDF in the iframe
      const url = URL.createObjectURL(pdfDoc);
      iframe.src = url;

      // When the iframe is loaded, trigger print
      iframe.onload = function () {
        // Add event listener for afterprint
        window.addEventListener("afterprint", function cleanup() {
          document.body.removeChild(iframe);
          URL.revokeObjectURL(url);
          window.removeEventListener("afterprint", cleanup);
        });

        // Trigger print
        iframe.contentWindow.print();
      };
    }
  };

  useEffect(() => {
    if (!desktopEnv.isDesktop) return undefined;

    const runPrintCommand = () => {
      if (!selectedItems?.length) return;
      handleBulkAction("print");
    };

    const offInvoicePrint = commandBus.register({
      id: "invoice.print",
      title: "Print Selected Invoice",
      category: "Sales",
      run: () => runPrintCommand(),
    });

    const onInvoicePrint = () => runPrintCommand();
    window.addEventListener("desktop:invoice-print", onInvoicePrint);

    return () => {
      offInvoicePrint();
      window.removeEventListener("desktop:invoice-print", onInvoicePrint);
    };
  }, [desktopEnv.isDesktop, selectedItems, displayedInvoices]);

  const handleEditClick = (invoice) => {
    const selectedInvoiceData = [
      {
        id: invoice.id,
        voucherNumber: invoice.voucherNumber,
      },
    ];

    navigate("/editinvoice", {
      state: {
        selectedItemIds: [invoice.id],
        selectedInvoices: selectedInvoiceData,
      },
    });
  };

  const handleOpenReturnForInvoice = async (invoice) => {
    let enrichedInvoice = { ...invoice };
    let items = invoice.items || invoice.sales || [];

    // Always fetch show details so sale_item_id / customer fields are complete
    try {
      const res = await showSale({ id: invoice.id });
      const legacy = getLegacySaleDetailsFromShowResponse(res);

      if (legacy) {
        if (legacy.sales?.length) {
          items = legacy.sales;
        }
        enrichedInvoice = {
          ...invoice,
          items,
          sales: items,
          userId:
            legacy.user_id ??
            legacy.customer_id ??
            invoice.userId ??
            invoice.user_id,
          customerName:
            legacy.name ||
            legacy.customer_name ||
            invoice.customerName ||
            invoice.customer_name,
          customerMobile:
            legacy.mobile ||
            legacy.customer_mobile ||
            invoice.customerMobile ||
            invoice.customer_mobile,
          grandTotal: legacy.grand_total || invoice.grandTotal,
          final_amount: legacy.final_amount || invoice.final_amount,
          remainingAmount:
            legacy.remaining_amount || invoice.remainingAmount,
        };
      }
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      // Fall back to whatever the list row already has
    }

    if (!items.length) {
      toast.error("Selected invoice has no items to return");
      return;
    }

    setSelectedInvoiceForReturn(enrichedInvoice);
    await ensurePaymentTypesLoaded();
    setShowReturnModal(true);
  };

  return (
    <div className={`body-wrapper ${cardClass}`}>
      <div className="container-fluid">
        <div
          className={`card w-100 position-relative overflow-hidden ${cardClass}`}
        >
          <div className="px-4 py-3 border-bottom d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Sales Table</h4>
            <div className="d-flex gap-2">
              <button
                className={`btn btn-secondary ${buttonClass}`}
                onClick={() => navigate("/salesledger")}
              >
                Ledger
              </button>
              {!isQuoteMode && (
                <button
                  className={`btn btn-primary ${buttonClass}`}
                  onClick={() => navigate("/sales")}
                >
                  Add Sales
                </button>
              )}
            </div>
          </div>

          <div className="card-body p-4">
            {/* Search Section and Bulk Actions */}
            <div className="d-flex align-items-center mb-3">
              {/* Left side: Search Input */}
              <input
                type="text"
                className={`form-control ${buttonClass}`}
                style={{ maxWidth: "260px" }}
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
              />

              {/* Right side: Status + Actions */}
              <div className="ms-auto d-flex align-items-center gap-2">
                <select
                  className={`form-select w-auto ${buttonClass}`}
                  style={{ maxWidth: "200px" }}
                  value={statusFilter}
                  onChange={(e) => {
                    setStatusFilter(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="Active">Active</option>
                  <option value="Paid">Paid</option>
                  <option value="Pending">Pending</option>
                  <option value="Partially Paid">Partially Paid</option>
                  <option value="Return">Return</option>
                </select>

                {/* selectedItems.length > 0 && (
                  <div className="d-flex gap-2">
                    <div className="dropdown">
                      <button
                        className={`btn btn-outline-primary dropdown-toggle ${buttonClass}`}
                        type="button"
                        id="bulkActionDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        More
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="bulkActionDropdown"
                      >
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => handleBulkAction("edit")}
                          >
                            Edit Selected
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => handleBulkAction("export-to-pdf")}
                          >
                            Export to PDF
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => handleBulkAction("print")}
                          >
                            Print
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                ) */}
              </div>
            </div>

            {/* Table */}
            <div className={`table-responsive mb-4 border ${cardClass}`}>
              <table
                className={`table text-nowrap mb-0 align-middle invoice-table ${tableClass}`}
              >
                <thead className="text-dark fs-4">
                  <tr
                    onMouseEnter={() => setIsHeaderHovered(true)}
                    onMouseLeave={() => setIsHeaderHovered(false)}
                  >
                    {/* <th>
                      <div
                        style={{
                          visibility:
                            isHeaderHovered || selectedItems.length > 0
                              ? "visible"
                              : "hidden",
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          onChange={handleSelectAll}
                          checked={
                            selectedItems.length === displayedInvoices.length &&
                            displayedInvoices.length > 0
                          }
                          indeterminate={
                            selectedItems.length > 0 &&
                            selectedItems.length < displayedInvoices.length
                          }
                        />
                      </div>
                    </th> */}
                    <th>Invoice</th>
                    <th>Created By</th>
                    {/* <th>Tag No</th> */}
                    <th>Date</th>
                    <th>Customer</th>
                    <th>Mobile</th>
                    <th> Items</th>
                    <th>Total</th>
                    <th>Remaining</th>
                    {/* <th>Bank</th> */}
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="11" className="text-center">
                        Loading...
                      </td>
                    </tr>
                  ) : displayedInvoices.length > 0 ? (
                    displayedInvoices.map((invoice) => {
                      // const user = userss[invoice.userId] || {
                      //   name: "N/A",
                      //   mobile: "N/A",
                      // };

                      // Determine row class based on payment status
                      const isReturned =
                        invoice.status === "3" || invoice.status === 3;
                      const isPaid = parseFloat(invoice.remainingAmount) === 0;
                      const isPending =
                        parseFloat(invoice.remainingAmount) ===
                        parseFloat(invoice.grandTotal);

                      const rowClassName = isReturned
                        ? "status-returned-row"
                        : isPaid
                          ? "status-paid-row"
                          : isPending
                            ? "status-pending-row"
                            : "status-partial-row";

                      return (
                        <tr
                          key={invoice.id}
                          className={rowClassName}
                          onMouseEnter={() => setHoveredRow(invoice.id)}
                          onMouseLeave={() => setHoveredRow(null)}
                        >
                          {/* <td>
                            <div
                              style={{
                                visibility:
                                  hoveredRow === invoice.id ||
                                  selectedItems.includes(invoice.id)
                                    ? "visible"
                                    : "hidden",
                              }}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={selectedItems.includes(invoice.id)}
                                onChange={() =>
                                  handleCheckboxChange(invoice.id)
                                }
                              />
                            </div>
                          </td> */}
                          <td>{invoice.voucherNumber}</td>
                          <td>{invoice.byUserName || "N/A"}</td>
                          {/* <td>
                            {(() => {
                              const tagNos = (invoice.items || [])
                                .map((it) => it.tag_no || it.tagNo || it.tag || "")
                                .filter((v) => v && String(v).trim() !== "");
                              // Show unique tag numbers, comma-separated
                              const unique = Array.from(new Set(tagNos));
                              return unique.length > 0 ? unique.join(", ") : "-";
                            })()}
                          </td> */}
                          <td>{formatSaleListDateCell(invoice)}</td>
                          <td>{invoice.customerName}</td>
                          <td>{invoice.customerMobile}</td>
                          <td>{invoice.totalItems}</td>
                          <td>
                            {invoice.status === "3" || invoice.status === 3
                              ? formatIndianRupee(0)
                              : formatIndianRupee(invoice.grandTotal)}
                          </td>
                          <td>
                            {invoice.status === "3" || invoice.status === 3
                              ? formatIndianRupee(0)
                              : parseFloat(invoice.remainingAmount) === 0
                                ? "-"
                                : formatIndianRupee(invoice.remainingAmount)}
                          </td>
                          {/* <td>
                            {invoice.payments && invoice.payments.length > 0
                              ? invoice.payments
                                  .map(
                                    (payment) =>
                                      bankAccounts[payment.bank_type] ||
                                      "Unknown"
                                  )
                                  .filter(
                                    (value, index, self) =>
                                      self.indexOf(value) === index
                                  ) // Remove duplicates
                                  .map((bank, index) => (
                                    <div key={index}>{bank}</div>
                                  ))
                              : "N/A"}
                          </td> */}
                          <td>
                            <span
                              className={`badge ${invoice.status === "3" || invoice.status === 3
                                  ? "bg-secondary-subtle text-secondary"
                                  : parseFloat(invoice.remainingAmount) === 0
                                    ? "bg-success-subtle text-success"
                                    : parseFloat(invoice.remainingAmount) ===
                                      parseFloat(invoice.grandTotal)
                                      ? "bg-danger-subtle text-danger"
                                      : "bg-warning-subtle text-warning"
                                }`}
                            >
                              {invoice.status === "3" || invoice.status === 3
                                ? "Returned"
                                : parseFloat(invoice.remainingAmount) === 0
                                  ? "Paid"
                                  : parseFloat(invoice.remainingAmount) ===
                                    parseFloat(invoice.grandTotal)
                                    ? "Pending"
                                    : "Partially Paid"}
                            </span>
                          </td>
                          <td>
                            <button
                              className={`btn btn-primary btn-sm ${buttonClass}`}
                              onClick={async () => {
                                const enriched =
                                  await buildInvoiceWithDetails(invoice);
                                await ensurePaymentTypesLoaded();
                                const pdfInvoice = {
                                  ...enriched,
                                  ...resolveSaleEinvoiceFields(enriched),
                                };
                                if (pdfInvoice.signed_qr_code) {
                                  try {
                                    pdfInvoice.signed_qr_image =
                                      await buildSignedQrDataUrl(
                                        pdfInvoice.signed_qr_code,
                                      );
                                  } catch (qrErr) {
                                    console.error("QR generation failed:", qrErr);
                                    toast.error("Failed to generate e-invoice QR code");
                                  }
                                }
                                setSelectedInvoicesForPdf([
                                  {
                                    invoice: pdfInvoice,
                                    user: {
                                      name:
                                        enriched.customerDetails?.name ||
                                        invoice.customerName ||
                                        "N/A",
                                      mobile:
                                        enriched.customerDetails?.mobile ||
                                        invoice.customerMobile ||
                                        "N/A",
                                      email: "",
                                      state:
                                        enriched.customerDetails?.state || "0",
                                      city:
                                        enriched.customerDetails?.city || "",
                                      address:
                                        enriched.customerDetails?.address || "",
                                      aadhar_no:
                                        enriched.customerDetails?.aadhar_no ||
                                        "",
                                      pan_no:
                                        enriched.customerDetails?.pan_no || "",
                                      GST_number:
                                        enriched.customerDetails?.gst_number ||
                                        "",
                                      company_name: "",
                                      company_address: "",
                                      reference: "",
                                      status: "1",
                                    },
                                  },
                                ]);
                                setShowPdfSizeModal(true);
                              }}
                              title="Print Invoice"
                            >
                              <Icon
                                icon="solar:printer-bold"
                                width="16"
                                height="16"
                              />
                            </button>
                            <button
                              className={`btn btn-primary btn-sm ms-2 ${buttonClass}`}
                              onClick={() => handleOpenSettlementModal(invoice)}
                              disabled={
                                parseFloat(invoice.remainingAmount) <= 0 ||
                                invoice.status === "3" ||
                                invoice.status === 3
                              }
                              title={
                                parseFloat(invoice.remainingAmount) <= 0
                                  ? "No remaining amount"
                                  : "Payment Settlement"
                              }
                            >
                              <Icon
                                icon="solar:wallet-bold"
                                width="16"
                                height="16"
                              />
                            </button>
                            <button
                              className={`btn btn-primary btn-sm ms-2 ${buttonClass}`}
                              onClick={() => handleEditClick(invoice)}
                              title="Edit Invoice"
                            >
                              <Icon
                                icon="solar:pen-bold"
                                width="16"
                                height="16"
                              />
                            </button>
                            <button
                              className={`btn btn-primary btn-sm ms-2 ${buttonClass}`}
                              onClick={() =>
                                handleOpenReturnForInvoice(invoice)
                              }
                              disabled={
                                invoice.status === "3" || invoice.status === 3
                              }
                              title={
                                invoice.status === "3" || invoice.status === 3
                                  ? "Invoice already returned"
                                  : "Return Invoice"
                              }
                            >
                              <Icon
                                icon="solar:undo-left-bold"
                                width="16"
                                height="16"
                              />
                            </button>
                            {!isQuoteMode && (
                              <button
                                className={`btn btn-primary btn-sm ms-2 ${buttonClass}`}
                                onClick={() => {
                                  setGstPortalInvoiceIds([invoice.id]);
                                  setShowGstPortalModal(true);
                                }}
                                title="GST Portal"
                              >
                                <Icon
                                  icon="solar:document-text-bold"
                                  width="16"
                                  height="16"
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center">
                        No invoices found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <Pagination
              totalItems={totalCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleItemsPerPageChange}
              itemsPerPageOptions={[10, 20, 30, 50, 100]}
            />
          </div>
        </div>
      </div>

      {/* Edit Invoice Modal */}
      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedInvoice && (
            <Form>
              <div className="row">
                <div className="mb-3 col-md-12">
                  <Form.Label>Status</Form.Label>
                  <div className="d-flex gap-3">
                    <Form.Check
                      type="radio"
                      label="Active"
                      name="status"
                      value="Active"
                      checked={selectedInvoice.status === "1"}
                      onChange={(e) =>
                        setSelectedInvoice({
                          ...selectedInvoice,
                          status: "1",
                        })
                      }
                    />
                    <Form.Check
                      type="radio"
                      label="Inactive"
                      name="status"
                      value="Inactive"
                      checked={selectedInvoice.status === "0"}
                      onChange={(e) =>
                        setSelectedInvoice({
                          ...selectedInvoice,
                          status: "0",
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowEditModal(false)}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Success Modal */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Body className="text-center">
          <div className="d-flex flex-column align-items-center">
            <BiCheckCircle size={60} color="green" />
            <h5 className="mt-3">Successfully Submitted</h5>
          </div>
        </Modal.Body>
      </Modal>

      {/* Payment Settlement Modal */}
      <Modal
        show={showSettlementModal}
        onHide={handleCloseSettlementModal}
        centered
        size="xl"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Payment Settlement</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3 pb-1 px-4">
          {isSettlementLoading ? (
            <div className="d-flex justify-content-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              <div className="row g-3 mb-3">
                <div className="col-md-4">
                  <div
                    className={`h-100 rounded-0 border bg-white p-3 ${buttonClass}`}
                  >
                    <div className="text-uppercase small fw-semibold text-dark">
                      Total Amount
                    </div>
                    <div className={`fw-bold fs-5 mt-1 ${buttonClass}`}>
                      <strong>{formatIndianRupee(settlementGrandTotal)}</strong>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div
                    className={`h-100 rounded-0 border bg-white p-3 ${buttonClass}`}
                  >
                    <div className="text-uppercase small fw-semibold text-dark">
                      Remaining Amount
                    </div>
                    <div
                      className="fw-bold fs-5 mt-1"
                      style={{ color: "var(--theme-primary)" }}
                    >
                      {formatIndianRupee(settlementRemainingAmount)}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div
                    className={`h-100 rounded-0 border bg-white p-3 ${buttonClass}`}
                  >
                    <div className="text-uppercase small fw-semibold text-dark">
                      New Payment Total
                    </div>
                    <div className={`fw-bold fs-5 mt-1 ${buttonClass}`}>
                      <strong>
                        {formatIndianRupee(newSettlementAmountTotal)}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>

              {existingSettlementPayments.length > 0 ? (
                <div className="mb-3">
                  <div
                    className={`d-flex justify-content-between align-items-center border rounded-0 px-3 py-2 mb-2 bg-white ${buttonClass}`}
                  >
                    <h6 className="fw-semibold mb-0 text-dark text-uppercase small">
                      Previous Payments
                    </h6>
                    <button
                      type="button"
                      className={`btn btn-outline-secondary btn-sm d-flex align-items-center gap-1 ${buttonClass}`}
                      onClick={() =>
                        setIsPreviousPaymentsExpanded((prev) => !prev)
                      }
                    >
                      <Icon
                        icon={
                          isPreviousPaymentsExpanded
                            ? "solar:eye-closed-bold"
                            : "solar:eye-bold"
                        }
                        width={18}
                        height={18}
                      />
                      {isPreviousPaymentsExpanded ? "Hide" : "View"}
                    </button>
                  </div>
                  {isPreviousPaymentsExpanded && (
                    <div
                      className={`table-responsive rounded-0 border overflow-hidden ${cardClass} ${buttonClass}`}
                    >
                      <table
                        className={`table table-sm mb-0 align-middle ${tableClass}`}
                      >
                        <thead className="bg-body-tertiary text-secondary small text-uppercase">
                          <tr>
                            <th
                              className="text-center"
                              style={{ width: "60px" }}
                            >
                              #
                            </th>
                            <th style={{ width: "140px" }}>Date</th>
                            <th>Mode</th>
                            <th>Type</th>
                            <th>Remarks</th>
                            <th className="text-end" style={{ width: "140px" }}>
                              Amt
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {existingSettlementPayments.map((payment, index) => {
                            const paymentDate =
                              payment.transaction_date ||
                              payment.date ||
                              payment.created_at ||
                              "";
                            return (
                              <tr key={payment.id || index}>
                                <td className="text-center">{index + 1}</td>
                                <td>
                                  {paymentDate ? formatDate(paymentDate) : "-"}
                                </td>
                                <td>
                                  {isUrdLinkedPaymentMode(
                                    payment.payment_mode,
                                  ) || Number(payment.urd_document_id) > 0
                                    ? formatApiPaymentDisplayLabel(payment)
                                    : payment.payment_mode || "-"}
                                </td>
                                <td>
                                  {isUrdLinkedPaymentMode(
                                    payment.payment_mode,
                                  ) || Number(payment.urd_document_id) > 0
                                    ? "Linked URD"
                                    : payment.bank_name || "-"}
                                </td>
                                <td>{payment.remarks || "-"}</td>
                                <td className="text-end">
                                  {formatIndianRupee(
                                    parseNumericValue(payment.amount),
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ) : (
                <div className="mb-3 small text-muted">
                  No previous settlement payments recorded for this invoice.
                </div>
              )}

              <h6 className="fw-semibold mb-2 text-dark text-uppercase small">
                Add New Payments
              </h6>
              <div
                className={`table-responsive rounded-0 border overflow-hidden ${cardClass} ${buttonClass}`}
              >
                <table
                  className={`table table-sm align-middle mb-0 ${tableClass}`}
                >
                  <thead className="bg-primary-subtle text-secondary small text-uppercase">
                    <tr>
                      <th className="text-center" style={{ width: "60px" }}>
                        #
                      </th>
                      <th>Mode </th>
                      <th style={{ width: "220px" }}>Type </th>
                      <th style={{ minWidth: "160px" }}>Remarks</th>
                      <th className="text-end" style={{ width: "150px" }}>
                        Amt 
                      </th>
                      <th className="text-center" style={{ width: "80px" }}>
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {settlementRows.map((row, index) => (
                      <tr key={row.id}>
                        <td className="text-center">{index + 1}</td>
                        <td>
                          <Select
                            options={SETTLEMENT_METHOD_OPTIONS}
                            value={
                              SETTLEMENT_METHOD_OPTIONS.find(
                                (opt) => opt.value === row.pay_mode,
                              ) || null
                            }
                            onChange={(option) =>
                              handleSettlementRowChange(
                                row.id,
                                "pay_mode",
                                option ? option.value : "",
                              )
                            }
                            placeholder="Select Method"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({
                                ...base,
                                minHeight: "31px",
                                height: "31px",
                              }),
                            }}
                            classNamePrefix="react-select"
                          />
                        </td>
                        <td>
                          {row.pay_mode === "kasar" ? (
                            <span className="text-muted small px-1">—</span>
                          ) : (
                            <Select
                              options={paymentTypes}
                              value={
                                paymentTypes.find(
                                  (opt) => opt.value === row.type,
                                ) || null
                              }
                              onChange={(option) =>
                                handleSettlementRowChange(
                                  row.id,
                                  "type",
                                  option ? option.value : "",
                                )
                              }
                              placeholder="Select Type"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                control: (base) => ({
                                  ...base,
                                  minHeight: "31px",
                                  height: "31px",
                                }),
                              }}
                              classNamePrefix="react-select"
                            />
                          )}
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            className={`shadow-none ${buttonClass}`}
                            type="text"
                            placeholder="Remarks"
                            value={row.remarks}
                            onChange={(e) =>
                              handleSettlementRowChange(
                                row.id,
                                "remarks",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            className={`shadow-none text-end ${buttonClass}`}
                            type="number"
                            min="0"
                            step="0.01"
                            placeholder="0.00"
                            value={row.amount}
                            onChange={(e) =>
                              handleSettlementRowChange(
                                row.id,
                                "amount",
                                e.target.value,
                              )
                            }
                            onFocus={() => handleSettlementAmountFocus(row.id)}
                          />
                        </td>
                        <td className="text-center">
                          <Button
                            variant="outline-secondary"
                            style={{
                              borderColor: "var(--theme-primary)",
                              color: "var(--theme-primary)",
                            }}
                            size="sm"
                            disabled={settlementRows.length === 1}
                            onClick={() => handleSettlementRowRemove(row.id)}
                          >
                            <Icon
                              icon="solar:trash-bin-minimalistic-bold"
                              width={16}
                              height={16}
                              style={{ color: "var(--theme-primary)" }}
                            />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-end gap-2">
          <Button
            variant="outline-primary"
            className={buttonClass}
            onClick={() => handleSaveSettlement({ print: true })}
            disabled={isSettlementSaving || isSettlementLoading}
          >
            {isSettlementSaving ? "Saving..." : "Save & Print"}
          </Button>
          <Button
            variant="primary"
            className={buttonClass}
            onClick={() => handleSaveSettlement({ print: false })}
            disabled={isSettlementSaving || isSettlementLoading}
          >
            {isSettlementSaving ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                />
                Saving...
              </>
            ) : (
              "Save"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* PDF Size Selection Modal */}
      <Modal
        show={showPdfSizeModal}
        onHide={() => {
          setShowPdfSizeModal(false);
          setSelectedInvoicesForPdf([]);
        }}
        centered
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Invoice Size</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-3">
            Choose the paper size for the invoice preview.
          </p>
          <div className="d-grid gap-2">
            <Button
              variant="outline-primary"
              className={buttonClass}
              onClick={() => handlePdfSizeSelect("A4")}
            >
              A4 Size
            </Button>
            <Button
              variant="outline-primary"
              className={buttonClass}
              onClick={() => handlePdfSizeSelect("A5")}
            >
              A5 Size
            </Button>
            <Button
              variant="outline-primary"
              className={buttonClass}
              onClick={() => handlePdfSizeSelect("Cover")}
            >
              Cover
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <JamaVoucherPreviewModal
        show={showSettlementVoucherPreview}
        onHide={() => {
          setShowSettlementVoucherPreview(false);
          setSettlementVoucherData(null);
        }}
        voucherData={settlementVoucherData}
      />

      {/* PDF Modal */}
      <Modal
        show={showPdfModal}
        onHide={() => {
          setShowPdfModal(false);
          setSelectedInvoicesForPdf([]);
          setPdfPaperSize("A4");
        }}
        size="xl"
        centered
        dialogClassName="pdf-modal"
      >
        <Modal.Header className="d-flex align-items-center justify-content-between">
          <Modal.Title>Invoice PDF Preview</Modal.Title>
          <div className="d-flex align-items-center gap-2">
            {pdfPaperSize === "A4" && (
              <button
                type="button"
                className="btn border-0 bg-transparent p-0 shadow-none"
                onClick={handleDownloadPdfWithLetterPad}
                title="Download on Letter Pad"
                aria-label="Download on Letter Pad"
              >
                <Icon
                  icon="solar:download-minimalistic-bold-duotone"
                  width="22"
                  height="22"
                  style={{ color: "var(--theme-primary)" }}
                />
              </button>
            )}
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setShowPdfModal(false);
                setSelectedInvoicesForPdf([]);
                setPdfPaperSize("A4");
              }}
            />
          </div>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh", overflow: "auto" }}>
          {pdfContent}
        </Modal.Body>
      </Modal>

      {/* Bill Cover Preview Modal */}
      <Modal
        show={showCoverModal}
        onHide={() => {
          setShowCoverModal(false);
          setSelectedInvoicesForPdf([]);
        }}
        size="xl"
        centered
        dialogClassName="pdf-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Bill Cover Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh", overflow: "auto" }}>
          {coverPdfContent}
        </Modal.Body>
      </Modal>

      {/* Return Modal */}
      <ReturnModal
        show={showReturnModal}
        onHide={() => {
          setShowReturnModal(false);
          setSelectedInvoiceForReturn(null);
        }}
        invoice={selectedInvoiceForReturn}
        users={userss}
        bankAccountsList={bankAccountsList}
        paymentTypes={paymentTypes}
        onSuccess={() => fetchInvoices(currentPage, itemsPerPage, searchQuery)}
      />

      <GstPortalModal
        show={showGstPortalModal}
        onHide={() => {
          setShowGstPortalModal(false);
          setGstPortalInvoiceIds([]);
        }}
        selectedInvoiceIds={gstPortalInvoiceIds}
        displayedInvoices={displayedInvoices}
        buildInvoiceWithDetails={buildInvoiceWithDetails}
        onImported={() => fetchInvoices(currentPage, itemsPerPage, searchQuery)}
      />
    </div>
  );
}

export default Invoice;
